
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { toast } from '../../../utils/common';
import moment from 'moment';
import { PriceData, CodeFormProps, formDataProps } from '@/interface/top-up-active';
import { getGradesOptions, postEditActive, getValidSpecialGoods } from '@/api/top-up-active';
import SingleImageUpload from '@/components/SingleImageUpload/index.vue';
import { rules, typeOptions, imageDescModel } from './config';
import { log } from 'console';

@Component({
  components: { SingleImageUpload },
})
export default class ExchangePop extends Vue {
  @Prop() visible!: Boolean;
  @Prop() formData!: formDataProps;
  rules = rules;
  confirmVisible = false;
  codeForm: CodeFormProps = {
    id: undefined,
    kind: 1,
    gradeType: 'coin',
    pageBG: {
      pc: { imageUrl: undefined },
      web: { imageUrl: '' },
    },
    pageBtn: { pc: { imageUrl: '' }, web: { imageUrl: '' } },
    pageDisabledBtn: { pc: { imageUrl: '' }, web: { imageUrl: '' } },
    prizes: [{ key: 1 }],
    activeTime: [],
    intro: '-',
    intro01: '',
    tag_string: '',
  };
  awaitSubmitParams: formDataProps | null = null;

  loading = false;
  options = typeOptions;
  gradeOptions = [];
  goodsOptions = [];
  imageDescModel = imageDescModel;

  async mounted() {
    const {
      bg_img_pc,
      bg_img_ter,
      click_btn_pc,
      click_btn_ter,
      over_btn_pc,
      over_btn_ter,
      card_grade,
      sp_good_id,
      start_time,
      end_time,
      prizes,
      yun_grade,
      ...otherData
    } = this.formData;
    if (bg_img_pc) this.codeForm.pageBG.pc.imageUrl = bg_img_pc;
    if (bg_img_ter) this.codeForm.pageBG.web.imageUrl = bg_img_ter;
    if (click_btn_pc) this.codeForm.pageBtn.pc.imageUrl = click_btn_pc;
    if (click_btn_ter) this.codeForm.pageBtn.web.imageUrl = click_btn_ter;
    if (over_btn_pc) this.codeForm.pageDisabledBtn.pc.imageUrl = over_btn_pc;
    if (over_btn_ter) this.codeForm.pageDisabledBtn.web.imageUrl = over_btn_ter;

    let gradeType = 'coin';
    if (card_grade) {
      gradeType = 'card';
    } else if (sp_good_id) {
      gradeType = 'spGoods';
    } else if (yun_grade) {
      gradeType = 'yun';
    }

    await this.gradeTypeChange(gradeType);

    this.codeForm = {
      ...this.codeForm,
      ...otherData,
      ...(prizes && prizes.length > 0 && { prizes: prizes.map(({ odds = 0, ...item }) => ({ ...item, odds: odds / 10 })) }),
      gradeType,
      card_grade,
      yun_grade,
      activeTime: [start_time ? moment(start_time * 1000) : undefined, end_time ? moment(end_time * 1000) : undefined],
    };

    // console.log(this.codeForm, 'codeForm');
  }

  // 充值档位切换
  gradeTypeChange(type: string) {
    this.codeForm.card_grade = undefined;
    this.codeForm.coin_grade = undefined;
    this.codeForm.sp_good_id = undefined;
    this.codeForm.yun_grade = undefined;
    this.gradeOptions = [];
    console.log(type, 'type---');

    if (type === 'spGoods') {
      getValidSpecialGoods({ page: 0, page_size: 0 }).then(resp => {
        const { code, data, msg } = resp || {};
        if (code === 0) {
          this.goodsOptions = data.list;
          if (this.formData.sp_good_id) {
            this.codeForm.sp_good_id = this.formData.sp_good_id;
          }
        } else {
          toast(msg, 'error');
        }
      });
    } else {
      if (this.codeForm.intro01 && this.codeForm.intro01.length > 12) {
        this.codeForm.intro01 = this.codeForm.intro01.substr(0, 12);
      }
      getGradesOptions({ kind: type }).then(ret => {
        const { code, data = [], msg } = ret || {};
        if (code === 0) {
          this.gradeOptions = data;
        } else {
          toast(msg, 'error');
        }
      });
    }
  }

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        const { id } = this.formData;
        const { gradeType, part_in = undefined, activeTime = [], pageBG, pageBtn, pageDisabledBtn, prizes, intro, ...otherProps } = this.codeForm;
        if (prizes.length <= 0) {
          return;
        }
        const { pc: { imageUrl: bg_img_pc = undefined } = {}, web: { imageUrl: bg_img_ter = undefined } = {} } = pageBG || {};
        const { pc: { imageUrl: click_btn_pc = undefined } = {}, web: { imageUrl: click_btn_ter = undefined } = {} } = pageBtn || {};
        const { pc: { imageUrl: over_btn_pc = undefined } = {}, web: { imageUrl: over_btn_ter = undefined } = {} } = pageDisabledBtn || {};
        const params: formDataProps = {
          id,
          ...otherProps,
          part_in: part_in ? part_in : 0,
          bg_img_pc: bg_img_pc || undefined,
          bg_img_ter: bg_img_ter || undefined,
          click_btn_pc: click_btn_pc || undefined,
          click_btn_ter: click_btn_ter || undefined,
          over_btn_pc: over_btn_pc || undefined,
          over_btn_ter: over_btn_ter || undefined,
          start_time: activeTime && activeTime[0] ? Number(moment(activeTime[0]).format('X')) : undefined,
          end_time: activeTime && activeTime[1] ? Number(moment(activeTime[1]).format('X')) : undefined,
          prizes: prizes.map(({ key, odds, ...item }) => ({ ...item, odds: odds ? Number(odds) * 10 : undefined })),
        };
        if (params.sp_good_id) {
          const spGoods: any = this.goodsOptions.find((item: any) => item.id == params.sp_good_id);
          if (spGoods) {
            params.sp_good_name = spGoods.name;
          }
        }
        this.awaitSubmitParams = params;
        this.confirmVisible = true;
      } else {
        return false;
      }
    });
  }

  @Emit()
  close() {}

  /**
   * 二次确认框取消
   */
  confirmClose() {
    this.awaitSubmitParams = null;
    this.confirmVisible = false;
  }
  /**
   * 二次确认框确定
   */
  confirmSubmit() {
    if (!this.awaitSubmitParams) {
      return;
    }
    postEditActive(this.awaitSubmitParams)
      .then((ret: any) => {
        const { code, msg } = ret || {};
        if (code === 0) {
          toast('成功', 'success');
          this.$emit('ok');
        } else {
          toast(msg, 'error');
        }
      })
      .finally(this.confirmClose);
  }

  /**
   * 新增
   */
  addPrice() {
    this.codeForm.prizes.push({
      key: Math.floor(Math.random() * 100000),
    });
  }

  removePrice(data: PriceData) {
    this.codeForm.prizes = this.codeForm.prizes.filter((item): any => item != data);
  }
}
